import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

const initialValues = {
  selectedCompany: null,
  activeTimer: null,
  timerElapsed: 0,
  dailyEntries: [],
  monthlyData: {},
  timeTrackingEnabled: false,
  selectedDate: null,
  isDailyModalOpen: false,
  isEntryFormOpen: false,
  editingEntry: null,
};

export const useTimeTrackingStore = create(
  persist(
    devtools(
      immer((set) => ({
        ...initialValues,

        setActiveTimer: (timer) =>
          set((state) => {
            state.activeTimer = timer;
            state.timerElapsed = 0;
          }),

        tickTimer: () =>
          set((state) => {
            if (state.activeTimer?.timerStartedAt) {
              const start = new Date(
                state.activeTimer.timerStartedAt
              ).getTime();
              state.timerElapsed = Math.floor((Date.now() - start) / 1000);
            }
          }),

        setSelectedCompany: (company) =>
          set((state) => {
            state.selectedCompany = company;
          }),

        setDailyEntries: (entries) =>
          set((state) => {
            state.dailyEntries = entries;
          }),
        setMonthlyData: (data) =>
          set((state) => {
            state.monthlyData = data;
          }),
        setTimeTrackingEnabled: (enabled) =>
          set((state) => {
            state.timeTrackingEnabled = enabled;
          }),
        setSelectedDate: (date) =>
          set((state) => {
            state.selectedDate = date;
          }),

        openDailyModal: (date) =>
          set((state) => {
            state.selectedDate = date;
            state.isDailyModalOpen = true;
          }),
        closeDailyModal: () =>
          set((state) => {
            state.isDailyModalOpen = false;
            state.editingEntry = null;
          }),

        openEntryForm: (entry = null) =>
          set((state) => {
            state.isEntryFormOpen = true;
            state.editingEntry = entry;
          }),
        closeEntryForm: () =>
          set((state) => {
            state.isEntryFormOpen = false;
            state.editingEntry = null;
          }),

        reset: () => set(initialValues),
      })),
      { name: 'TimeTrackingStore', trace: true }
    ),
    {
      name: 'tt-store',
      partialize: (state) => ({ selectedCompany: state.selectedCompany }),
    }
  )
);
